import {
    container,
    description,
    blackColor,
    whiteColor,
    grayColor,
    hexToRgb
  } from "./material-kit-pro-react.jsx";
  
  const signupPageStyle = theme => ({
    description,
    cardTitle: {
      
      color: whiteColor + "  !important",
      fontFamily: "Roboto-Regular",
      fontWeight:"bold",
      fontSize:"24px",
      height:"50px",
      paddingTop:"10px"
    },
    container: {
      ...container,
      zIndex: "4",
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "100px"
      }
    },
    pageHeader: {
      color: whiteColor,
      border: "0",
      height: "100%",
      margin: "0",
      display: "flex!important",
      padding: "120px 0",
      position: "relative",
      minHeight: "100vh",
      alignItems: "center",
      "&:before": {
        background: "rgba(" + hexToRgb(blackColor) + ", 0.5)"
      },
      "&:before,&:after": {
        position: "absolute",
        zIndex: "1",
        width: "100%",
        height: "100%",
        display: "block",
        left: "0",
        top: "0",
        content: '""'
      }
    },
    form: {
      margin: "0",
      marginTop:"-15px"
   
    },
    cardHeader: {
      width: "auto",
      textAlign: "center"
    },
    socialLine: {
      marginTop: "1rem",
      textAlign: "center",
      padding: "0"
    },
    inputIconsColor: {
      color: grayColor[13]
    },
    textCenter: {
      textAlign: "center",
      textTransform:"none"
    },
    iconButtons: {
      marginRight: "3px !important",
      marginLeft: "3px !important"
    },
    block: {
      color: "inherit",
      padding: "0.9375rem",
      fontWeight: "500",
      fontSize: "12px",
      textTransform: "uppercase",
      borderRadius: "3px",
      textDecoration: "none",
      position: "relative",
      display: "block"
    },
    inlineBlock: {
      display: "inline-block",
      padding: "0px",
      width: "auto"
    },
    list: {
      marginBottom: "0",
      padding: "0",
      marginTop: "0"
    },
    left: {
      float: "left!important",
      display: "block",
      "&,& *,& *:hover,& *:focus": {
        color: whiteColor + "  !important"
      }
    },
    right: {
      padding: "15px 0",
      margin: "0",
      float: "right",
      "&,& *,& *:hover,& *:focus": {
        color: whiteColor + "  !important"
      }
    },
    icon: {
      width: "18px",
      height: "18px",
      top: "3px",
      position: "relative"
    },
    footer: {
      position: "absolute",
      width: "100%",
      background: "transparent",
      bottom: "0",
      color: whiteColor,
      zIndex: "2"
    },
    card:{
        width:"130%",
        [theme.breakpoints.down('sm')]:{
            width:"100%",
        }

    },
    button:{
        textTransform:"none",
        width:"35%",
        borderRadius:"30px",
        fontSize:'17px',
        fontWeight:"bold",
        marginTop:"5%",
        outline:"none",
        height:"auto",
        textAlign:"center"
    },
    forgot:{
        textTransform:"none",
        alignItems:"right",
        justifyContent:"right",
        color:"#BEBEBE",
        marginRight:"7px"
    },
    checkboxdiv:{
        display: "flex",
        justifyContent:"flex-start",
        flexDirection: "row",
        marginLeft: "35px",
        paddingBottom:"10px"

    },
    input:{
        border: 0,
        width: "24em",
        borderBottomWidth: ".3",
        borderBottom: "1px solid #BEBEBE",
        marginLeft: "22px",
        height: "5vh",
        marginTop: "14px",
       
        '&::placeholder':{
          color:"#BEBEBE",
          
        }
    }
  });
  
  export default signupPageStyle;